export * from './IconDocBlank';
